module.exports = __webpack_public_path__ + "static/media/SAM_0033.6e15e192.JPG";